import React, { FC, useState } from "react";
import { Button, message } from "antd";
import { VideoPlayerModal } from "../../components/common";

interface Props {}

export const VideoModalTest: FC<Props> = () => {
  const [modalVisible, setModalVisible] = useState(false);

  const handleOpenModal = () => {
    setModalVisible(true);
  };

  const handleCloseModal = () => {
    setModalVisible(false);
  };

  // 使用本地测试视频
  const testVideoUrl = "/video/video1.mp4";

  return (
    <div style={{ padding: "20px" }}>
      <h1>视频弹窗测试</h1>
      <Button type="primary" onClick={handleOpenModal}>
        打开视频弹窗
      </Button>
      
      <div style={{ marginTop: "20px" }}>
        <h3>测试信息：</h3>
        <p>视频URL: {testVideoUrl}</p>
        <p>视频名称: 测试视频</p>
      </div>

      <VideoPlayerModal
        visible={modalVisible}
        onClose={handleCloseModal}
        videoUrl={testVideoUrl}
        videoName="测试视频"
        videoStatus="2"
        videoCreateTime="2025-01-01 12:00:00"
        videoMessage="这是一个测试视频"
        videoId="123"
      />
    </div>
  );
};
